import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { loginApi } from '../Http/http';
import Cookies from "js-cookie";

const Auth = ({ children }) => {
    const navigate = useNavigate();

    const handleCheckSubscription = async () => {
        try {
            const response = await loginApi(Cookies.get("msisdn"));
        } catch (error) {
            if (error?.response?.status == 403) {
                Cookies.remove("msisdn");
                navigate("/");
            }

            else if (error?.response?.data?.error?.status == 0) {
                Cookies.remove("msisdn");
                navigate("/");
            }
            else if (error?.response?.data?.error?.status == 1) {
                Cookies.remove("msisdn");
                navigate("/");
            }
            else {
                console.log("Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if (!Cookies.get("msisdn")) {
            navigate("/");
        }
        else {
            handleCheckSubscription();
        }
    }, []);
    return (
        <>
            {children}
        </>
    )
}

export default Auth